const showProgressModal = ({ dispatch, message = null }) => {
  dispatch('progressModal/showProgressModal', { message }, { root: true })
}

export default showProgressModal
